export default {
  inject: ['$vv'],
  computed: {
    $v() {
      return this.$vv || this.$v
    }
  }
}
